import { useOktaAuth } from "@okta/okta-react";
import { useContext } from "react";
import { AppBar, Toolbar, Typography, Button, Box, Divider } from "@mui/material";
import { Logout, GroupAdd, PersonAdd } from "@mui/icons-material";
import { Office365GroupContext } from "./context/Office365GroupContext";
import { ManagedAccountContext } from "./context/ManagedAccountContext";

const WSU_RED = "#A60F2D";

const navButtonSx = {
    color: "white",
    fontWeight: 500,
    letterSpacing: 0.3,
    textTransform: "none",
    fontSize: "0.875rem",
    px: 1.5,
    "&:hover": { backgroundColor: "rgba(255,255,255,0.12)" },
};

export const CrimsonServiceDeskHeader = () => {
    const { authState, oktaAuth } = useOktaAuth();
    const { setGroupModule } = useContext(Office365GroupContext);
    const { setManagedAccountModule } = useContext(ManagedAccountContext);

    const isTier3 = authState?.accessToken?.claims?.itsTier3;
    const isDistributedTier3 = authState?.accessToken?.claims?.distributedItTier3;

    return (
        <AppBar
            position="fixed"
            elevation={2}
            sx={{ backgroundColor: WSU_RED, zIndex: 20 }}
        >
            <Toolbar sx={{ display: "flex", justifyContent: "space-between", minHeight: 64 }}>

                {/* Title */}
                <Typography
                    variant="h6"
                    fontWeight={700}
                    letterSpacing={1}
                    sx={{ userSelect: "none" }}
                >
                    Tech Tools
                </Typography>

                {/* Nav Actions */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {(isTier3 || isDistributedTier3) && (
                        <Button
                            startIcon={<GroupAdd />}
                            sx={navButtonSx}
                            onClick={() => setGroupModule((prev) => ({ ...prev, mode: "create", isOpen: true }))}
                        >
                            Create Office 365 Group
                        </Button>
                    )}

                    {isTier3 && (
                        <Button
                            startIcon={<PersonAdd />}
                            sx={navButtonSx}
                            onClick={() => setManagedAccountModule((prev) => ({ ...prev, mode: "create", isOpen: true }))}
                        >
                            Create Managed Account
                        </Button>
                    )}

                    {(isTier3 || isDistributedTier3) && (
                        <Divider orientation="vertical" flexItem sx={{ borderColor: "rgba(255,255,255,0.25)", mx: 1 }} />
                    )}

                    <Button
                        startIcon={<Logout />}
                        sx={navButtonSx}
                        onClick={() => oktaAuth.signOut()}
                    >
                        Log Out
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
};